/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetUserProfileResponse } from '../entities/GetUserProfileResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { userModelSchema } from './userModelSchema'
import { z } from 'zod'

export const getUserProfileResponseSchema = z.object({
  user: z.lazy(() => userModelSchema).optional(),
}) as unknown as ToZod<GetUserProfileResponse>